import { render } from "./KiesseAvatar.vue?vue&type=template&id=6a9dde63&ts=true"
import script from "./KiesseAvatar.vue?vue&type=script&lang=ts"
export * from "./KiesseAvatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__